import Logo from './Logo.component';
export default Logo;